/* Canguaru featured video runtime (QA11 item 4) — one runtime for every
   [data-cg-video] instance: F1 (canguaru-featured) and the events featured
   insert. Behaviours: lazy sources (attached on first viewport entry),
   autoplay muted loop playsinline, WCAG 2.2.2 pause/play toggle,
   IntersectionObserver off-viewport pause, reduced-motion = poster only
   (playback never initialised).

   Delegated + MutationObserver-driven so instances survive Horizon's facet
   section morphs (morphed-in nodes never re-execute inline scripts — this
   is why the runtime is a global asset, not per-instance script tags). */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var wired = new WeakSet();

  function load(video) {
    if (video.dataset.cgLoaded) return;
    video.dataset.cgLoaded = '1';
    video.querySelectorAll('source[data-src]').forEach(function (s) {
      s.src = s.dataset.src;
    });
    video.load();
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting && !video.dataset.cgUserPaused) {
          load(video);
          video.play().catch(function () {});
        } else if (!entry.isIntersecting) {
          video.pause();
        }
      });
    },
    { threshold: 0.3 }
  );

  function init() {
    document.querySelectorAll('[data-cg-video]').forEach(function (video) {
      if (wired.has(video)) return;
      wired.add(video);
      io.observe(video);
      var scope = video.closest('[data-cg-video-scope]');
      var btn = scope && scope.querySelector('[data-cg-video-toggle]');
      if (btn) btn.hidden = false;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cg-video-toggle]');
    if (!btn) return;
    e.preventDefault();
    var scope = btn.closest('[data-cg-video-scope]');
    var video = scope && scope.querySelector('[data-cg-video]');
    if (!video) return;
    if (video.paused) {
      delete video.dataset.cgUserPaused;
      load(video);
      video.play().catch(function () {});
      btn.textContent = '❚❚';
      btn.setAttribute('aria-label', 'Pause video');
    } else {
      video.dataset.cgUserPaused = '1';
      video.pause();
      btn.textContent = '▶';
      btn.setAttribute('aria-label', 'Play video');
    }
  });

  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(init, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
